import { Button } from '@mantine/core';
import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteError } from 'react-router';

import { ErrorFallback } from '@/components/errors/ErrorFallback';

export default function ErrorPage() {
	const { t } = useTranslation();
	const error = useRouteError();

	useEffect(() => {
		if (error) {
			Sentry.captureException(error);
		}
	}, [error]);

	console.error(error);

	return (
		<ErrorFallback
			error={error}
			fullHeight
			extraContent={
				<Button component="a" href="/" variant="subtle">
					{t('common.goToDashboard')}
				</Button>
			}
		/>
	);
}
